// extracted by mini-css-extract-plugin
export default {"mypanel":"styles_mypanel__Z6ZbJ"};